function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2654",
  "data-name": "Path 2654",
  d: "M34 20v-6l8 8-8 8v-6H24v10h6l-8 8-8-8h6V24H10v6l-8-8 8-8v6h10V10h-6l8-8 8 8h-6v10z",
  transform: "translate(-2 -2)",
  fill: "#f5f5f5"
})));